import React from 'react';
import { Poppins } from 'src/common';
import { BaseCard } from '../../styled';
import styled from 'styled-components';
import { DashboardQuery } from 'src/graphql/_generated';
import { AssessmentState } from '../types';
import { DangerTooltip } from '../comps';

const Wrap = styled(BaseCard)`
  .grid {
    display: grid;
    grid-template-columns: 1.1fr 2fr;

    gap: 10px;
    height: 100%;

    &__item {
      margin-top: auto;
      display: flex;
      flex-direction: column;
      gap: 4px;

      height: 48px;

      &__value {
        margin-top: 6px;
        display: flex;
        svg {
          margin-bottom: 4px;
        }
      }
    }
  }
`;

export const customNumberFormatRI = (value: number | undefined) => (value ? parseFloat(value.toFixed(1)) : 0);

interface ReturnInvestmentmeProps {
  value: DashboardQuery['dashboard']['returnOnInvestment'];
  state: AssessmentState;
}

export const ReturnInvestment: React.FC<ReturnInvestmentmeProps> = ({ value, state }) => {
  const current = customNumberFormatRI(value?.currentProgramme);
  const future = customNumberFormatRI(value?.futureProgramme);
  return (
    <Wrap>
      <span className="c-title">Return on Investment</span>
      <div className="content">
        <span className="description">The risk reduction divided by the cost of your security programme.</span>
      </div>
      <div style={{ flex: 1 }} />

      <div className="grid">
        <div className="grid__item">
          <Poppins px={12} weight={500} nowrap>
            CURRENT PROGRAMME
          </Poppins>
          <div className="grid__item__value">
            {state === 'SCENARIOS_LIVE_CONTROLS_MODIFIERS' ||
            state === 'ALL_INFO_AVAILABLE' ||
            state === 'SCENARIOS_PENDING_CONTROLS_MODIFIERS' ? (
              <>
                <Poppins weight={600} px={26} color="gp1" className="value">
                  {current}
                  {current ? 'x' : ''}
                </Poppins>
              </>
            ) : (
              <DangerTooltip state={state} />
            )}
          </div>
        </div>

        <div className="grid__item">
          <Poppins px={12} weight={500}>
            FUTURE PROGRAMME
          </Poppins>
          <div className="grid__item__value">
            {state === 'SCENARIOS_LIVE_CONTROLS_MODIFIERS' ||
            state === 'ALL_INFO_AVAILABLE' ||
            state === 'SCENARIOS_PENDING_CONTROLS_MODIFIERS' ? (
              <>
                <Poppins weight={600} color="brightBlue" px={26} className="value">
                  {future}
                  {future ? 'x' : ''}
                </Poppins>
              </>
            ) : (
              <DangerTooltip state={state} />
            )}
          </div>
        </div>
      </div>
    </Wrap>
  );
};
